<template lang="pug">

form.ui.form(v-on:submit.prevent="submit()")

    //- Navigation
    navigation

    //- Formulare
    update-form(
        ref="form"
        v-bind:addressModel='addressModel'
        v-bind:companyModels='companyModels'
        v-bind:countryModels='countryModels'
        v-bind:stateModels='stateModels'
    )

</template>

<script>
    import store from '@/store'
    import Navigation from '@/components/addresses/Navigation'
    import UpdateForm from '@/components/addresses/UpdateForm'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        components: { Navigation, UpdateForm },

        async beforeRouteEnter(to, from, next) {
            await loadData(to.params.id)
            next()
        },

        async beforeRouteUpdate(to, from, next) {
            await loadData(to.params.id)
            next()
        },

        computed: {

            addressModel() {
                return store.getters['addresses/byId'](this.id)
            },

            companyModels() {
                return store.getters['companies/all']
            },

            countryModels() {
                return store.getters['countries/all']
            },

            id() {
                return Number(this.$route.params.id)
            },

            stateModels() {
                return store.getters['states/allByCountryId'](this.addressModel.country)
            },

        },

        methods: {

            cancel() {
                this.$router.push({ name: 'addresses' })
            },

            submit() {
                this.$refs.form.validate().then(isValid => {
                    if (isValid) {
                        this.$refs.form.persist().then(() => {
                            this.$router.push({ name: 'addresses' })
                            this.$growl.success('Adresse wurde gespeichert')
                        })
                    }
                })
            },

        }

    }

    async function loadData(id) {
        const [ addressModel ] = await Promise.all([

            // Adresse laden
            store.dispatch('addresses/loadOne', { id }),

            // Laender laden
            store.dispatch('countries/loadAll'),

            // Alle Unternehmen laden (für das Unternehmen-Dropdown)
            store.dispatch('companies/loadAll')
        ])

        const companyLinks = addressModel.companies || []
        const companyIds = companyLinks.map(link => link.company)

        return Promise.all([

            // Alle zugeordneten Unternehmen laden
            ...companyIds.map(companyId => store.dispatch('companies/loadOne', { id: companyId })),

            // Bundeslaender laden
            store.dispatch('states/loadAllByCountry', { countryId: addressModel.country })
        ].filter(Boolean))
    }

</script>
